const EXACT_NON_MAIN_TITLES = new Set([
  'folha de rosto',
  'expediente',
  'orelha',
  'dedicatoria',
  'agradecimentos',
  'epigrafe',
  'sumario',
  'introducao',
  'notas',
  'indice',
  'indice remissivo',
  'indice geral'
]);

const PREFIX_NON_MAIN_TITLES = [
  'prefacio',
  'apresentacao',
  'posfacio',
  'nota do autor',
  'nota do editor',
  'nota dos autores',
  'nota dos coordenadores',
  'anexo',
  'anexos',
  'apendice',
  'apendices',
  'referencias',
  'referencia bibliografica',
  'referencias bibliograficas',
  'bibliografia',
  'glossario',
  'sobre o autor',
  'sobre os autores',
  'sobre o coordenador',
  'sobre os coordenadores',
  'sobre o organizador',
  'sobre os organizadores',
  'lista de abreviaturas',
  'lista de siglas',
  'lista de abreviaturas e siglas'
];

function normalizeTitle(title: string): string {
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isMainChapterTitle(title?: string): boolean {
  if (!title) return false;
  const norm = normalizeTitle(title);
  if (!norm) return false;
  if (EXACT_NON_MAIN_TITLES.has(norm)) return false;
  for (const prefix of PREFIX_NON_MAIN_TITLES) {
    if (norm === prefix || norm.startsWith(`${prefix} `)) return false;
  }
  return true;
}
